module.exports = __webpack_public_path__ + "img/dark-mud-decal-10.932efea0.png";